/* ═══════════════════════════════════════════════════════════════════
   SELECTOR VARIANTE — selecție opțiuni, disponibilitate, preț, adăugare în coș
   ═══════════════════════════════════════════════════════════════════ */
(function () {
  "use strict";

  var RAL_HEX = {
    "8003": "#7e4b25", "8004": "#8e402a", "8017": "#45322e", "8019": "#3d3635",
    "9002": "#e7ebda", "9005": "#0a0a0a", "9006": "#a5a5a5", "9010": "#f1ece1",
    "3000": "#a52019", "3005": "#5e2129", "3009": "#642424", "3011": "#781f19",
    "5010": "#0e294b", "6005": "#114232", "6020": "#374231",
    "7011": "#252a30", "7016": "#293133", "7024": "#474a51"
  };

  function initVP(root) {
    var dataEl = root.querySelector("[data-vp-variants]");
    if (!dataEl) return;
    var variants;
    try { variants = JSON.parse(dataEl.textContent); } catch (e) { return; }
    if (!variants.length) return;

    var buttons = Array.prototype.slice.call(root.querySelectorAll("[data-vp-value]"));
    var priceEl = root.querySelector("[data-vp-price]");
    var totalEl = root.querySelector("[data-vp-total]");
    var isMeter = (function () { var u = ((totalEl && totalEl.dataset.vpUnit) || "").toLowerCase().trim(); return u === "m2" || u === "mp" || u === "m²"; })();
    function fmtLei(cents) { return (cents / 100).toFixed(2).replace(".", ",") + " lei"; }
    function updateTotal() {
      if (!totalEl) return;
      var v = currentVariant(), qty = Math.max(1, parseInt((qtyInput || {}).value, 10) || 1);
      if (!v || !v.cents || qty <= 1) { totalEl.textContent = ""; return; }
      totalEl.innerHTML = "Total " + qty + (isMeter ? " m²" : " buc") + ": <strong>" + fmtLei(v.cents * qty) + "</strong>";
    }
    var addBtn = root.querySelector("[data-vp-add]");
    var qtyInput = root.querySelector("[data-vp-qty-input]");
    var msgEl = root.querySelector("[data-vp-msg]");

    /* culori RAL fallback pe chip-uri fără imagine */
    root.querySelectorAll(".vp__chip").forEach(function (chip) {
      if (!chip.style.backgroundImage) {
        var ral = (chip.dataset.ral || "").match(/(\d{4})/);
        chip.style.backgroundColor = (ral && RAL_HEX[ral[1]]) || "#bbb";
      }
    });

    /* stare inițială: varianta DISPONIBILĂ cu prețul cel mai mic (nu prima din listă).
       Motiv: colecția, cardul de produs și meta title anunță „De la X lei"; dacă pagina
       se deschidea pe prima variantă din listă (de regulă cea mai groasă/scumpă),
       prețul afișat contrazicea promisiunea din listing. */
    var selected = {};
    var init = null;
    for (var i = 0; i < variants.length; i++) {
      if (!variants[i].available) continue;
      if (!init || variants[i].cents < init.cents) init = variants[i];
    }
    if (!init) init = variants[0];
    init.options.forEach(function (v, idx) { selected[idx] = v; });

    function currentVariant() {
      return variants.find(function (v) {
        return v.options.every(function (val, idx) { return selected[idx] === val; });
      });
    }

    function valueAvailable(optIdx, val) {
      /* există variantă disponibilă cu (val pe optIdx) + selecțiile curente pe celelalte opțiuni? */
      return variants.some(function (v) {
        if (!v.available) return false;
        if (v.options[optIdx] !== val) return false;
        for (var j in selected) {
          if (+j === optIdx) continue;
          if (v.options[+j] !== selected[j]) return false;
        }
        return true;
      });
    }

    function resolveSelection(optIdx, val) {
      /* Ajustează celelalte opțiuni la o combinație VALIDĂ care conține val pe optIdx.
         Fără asta, un click pe o grosime care nu se face în culoarea curentă lăsa
         selectorul în fundătură: preț gol, buton dezactivat, nicio explicație.
         Ordinea criteriilor: 1) în stoc, 2) păstrează cât mai mult din selecția
         curentă (să nu sară inutil culoarea), 3) la egalitate, cea mai ieftină. */
      var best = null, bestScore = -1;
      variants.forEach(function (v) {
        if (v.options[optIdx] !== val) return;
        var score = v.available ? 1000 : 0;
        for (var j in selected) {
          if (+j === optIdx) continue;
          if (v.options[+j] === selected[j]) score++;
        }
        /* la scor egal alegem varianta mai ieftină, ca să nu urcăm tacit prețul */
        if (score > bestScore || (score === bestScore && best && v.cents < best.cents)) { bestScore = score; best = v; }
      });
      if (!best) return; /* valoarea nu apare în nicio variantă — lăsăm starea neatinsă */
      best.options.forEach(function (ov, idx) { selected[idx] = ov; });
    }

    function update() {
      buttons.forEach(function (b) {
        var oi = +b.dataset.vpOpt, val = b.dataset.vpValue;
        var isSel = selected[oi] === val;
        b.classList.toggle("is-selected", isSel);
        b.classList.toggle("is-unavailable", !valueAvailable(oi, val));
        /* starea de selecție trebuie expusă asistiv, nu doar prin clasa CSS */
        b.setAttribute("aria-pressed", isSel ? "true" : "false");
      });
      /* numele culorii selectate lângă eticheta „Culoare" */
      root.querySelectorAll("[data-vp-sel]").forEach(function (el) {
        el.textContent = selected[+el.dataset.vpSel] || "";
      });
      var v = currentVariant();
      if (v) {
        /* Unitatea stă lipită de preț, nu doar în notița de dedesubt: pe un produs
           vândut la m² (tablă, gard) prețul singur se citește ca preț pe bucata întreagă.
           Carduri și quick-add o arată deja; pagina de produs era singura fără ea.
           Bara fixă copiază innerHTML din [data-vp-price], deci o preia automat. */
        var unitSuffix = isMeter ? '<span class="vp__price-unit">/m²</span>' : "";
        if (v.compare_at) {
          priceEl.innerHTML = '<span class="vp__price-compare">' + v.compare_at + '</span>'
                            + '<span class="vp__price-sale">' + v.price + unitSuffix + '</span>';
        } else {
          priceEl.innerHTML = v.price + unitSuffix;
        }
        addBtn.disabled = !v.available;
        addBtn.dataset.variantId = v.id;
        if (msgEl) msgEl.textContent = v.available ? "" : "Combinație indisponibilă";
      } else {
        priceEl.textContent = "";
        addBtn.disabled = true;
        addBtn.dataset.variantId = "";
        /* fallback: chiar și aici userul primește o explicație, nu un ecran mut */
        if (msgEl) msgEl.textContent = "Combinație indisponibilă";
      }
      updateTotal();
    }

    /* Comută imaginea principală (galeria Horizon) la varianta selectată, via section rendering.
       Horizon ascultă `variant:update` pe .shopify-section și înlocuiește <media-gallery>. */
    var handle = root.dataset.vpHandle;
    var galleryAbort = null;
    function updateGallery(variantId) {
      if (!variantId || !handle) return;
      var gallery = document.querySelector("media-gallery");
      if (!gallery) return;
      var section = gallery.closest(".shopify-section");
      if (!section) return;
      var sectionId = section.id.replace(/^shopify-section-/, "");
      if (galleryAbort) galleryAbort.abort();
      galleryAbort = new AbortController();
      fetch("/products/" + handle + "?variant=" + variantId + "&section_id=" + sectionId, { signal: galleryAbort.signal })
        .then(function (r) { return r.text(); })
        .then(function (txt) {
          var doc = new DOMParser().parseFromString(txt, "text/html");
          section.dispatchEvent(new CustomEvent("variant:update", {
            bubbles: true,
            detail: { resource: { id: variantId }, sourceId: "vp", data: { html: doc } },
          }));
        })
        .catch(function () {});
    }

    buttons.forEach(function (b) {
      b.addEventListener("click", function () {
        var oi = +b.dataset.vpOpt;
        selected[oi] = b.dataset.vpValue;
        /* combinația rezultată nu există deloc → re-rezolvăm restul opțiunilor.
           Dacă există dar e fără stoc, o păstrăm: mesajul explică situația. */
        if (!currentVariant()) resolveSelection(oi, b.dataset.vpValue);
        update();
        var v = currentVariant();
        if (v) updateGallery(v.id);
      });
    });

    /* cantitate */
    root.querySelectorAll("[data-vp-qty]").forEach(function (b) {
      b.addEventListener("click", function () {
        var step = parseInt(b.dataset.vpQty, 10);
        qtyInput.value = Math.max(1, (parseInt(qtyInput.value, 10) || 1) + step);
        updateTotal();
      });
    });
    if (qtyInput) qtyInput.addEventListener("input", updateTotal);

    /* adaugă în coș */
    addBtn.addEventListener("click", function () {
      var id = addBtn.dataset.variantId;
      if (!id) return;
      var qty = Math.max(1, parseInt(qtyInput.value, 10) || 1);
      addBtn.disabled = true;
      var label = addBtn.querySelector("span");
      var orig = label ? label.textContent : "";
      if (label) label.textContent = "Se adaugă…";
      fetch("/cart/add.js", {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify({ items: [{ id: parseInt(id, 10), quantity: qty }] })
      })
        .then(function (r) { if (!r.ok) return r.text().then(function (t) { throw new Error(t); }); return r.json(); })
        .then(function () {
          document.dispatchEvent(new CustomEvent("cart:update", { detail: { source: "silent" } }));
          if (label) label.textContent = "Adăugat ✓";
          setTimeout(function () { if (label) label.textContent = orig; addBtn.disabled = false; }, 1500);
          if (root.dataset.afterAdd === "stay") {
            /* rămâne pe pagină, fără drawer */
          } else if (window.__toCartDrawer !== false && document.querySelector("[data-tcd]")) {
            document.dispatchEvent(new CustomEvent("to:cart:open"));
          } else {
            window.location.href = "/cart";
          }
        })
        .catch(function (err) {
          if (msgEl) msgEl.textContent = "Eroare la adăugare în coș.";
          if (label) label.textContent = orig;
          addBtn.disabled = false;
          console.error("[vp] add to cart:", err);
        });
    });

    update();
  }

  function boot() { document.querySelectorAll("[data-vp]").forEach(initVP); }
  if (document.readyState === "loading") document.addEventListener("DOMContentLoaded", boot);
  else boot();
  document.addEventListener("shopify:section:load", boot);
})();
